import { useWalletClient } from 'wagmi';
export const useEcdsaProvider = () => {
    const { data: walletClient } = useWalletClient();
    if (!walletClient) {
        return null;
    }
    const ecdsaProvider = walletClient.ecdsaProvider;
    return ecdsaProvider;
};
